import * as CartService from '../services/CartService'

export const UPDATE_DATA_REQUEST = 'UPDATE_DATA_REQUEST';
export const UPDATE_DATA_SUCCESS = 'UPDATE_DATA_SUCCESS';
export const UPDATE_DATA_FAILURE = 'UPDATE_DATA_FAILURE';

export function updateDataRequest() {
    return {
        type: UPDATE_DATA_REQUEST
    }
}

export function updateDataSuccess(payload) {
    return {
        type: UPDATE_DATA_SUCCESS,
        payload
    }
}

export function updateDataFailure(payload) {
    return {
        type: UPDATE_DATA_FAILURE,
        payload
    }
}

export function updateData(data) {
    return (dispatch) => {
        dispatch(updateDataRequest());

        CartService.updateData(data)
            .then(response => {
                dispatch(updateDataSuccess(response));
            })
            .catch(error => {
                dispatch(updateDataFailure(error));
            });
    }
}
